
import Vue from "vue";
import Headline from "../components/shared/Headline.vue";

export default Vue.extend({
  name: "index",
  components: {
    Headline,
  },
});
